/* istanbul ignore file */
import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import {
  AddressInput,
  DateInput,
  PhoneInput,
  TextArea,
  TextInput,
  ClearAfterUnmountWrapper,
  TimezoneDropdown,
} from 'framework/form';
import PostponedReasonDropdown from 'domain/sales/lead/shared/input/PostponedReasonDropdown';
import CrmOwnerDropdownInput from 'domain/sales/shared/input/CrmOwnerDropdownInput';
import { useAuthorization } from 'framework/authorization';
import { CHANGE_OWNER } from 'domain/sales/salesService';
import { READ_FULL_LEADS_LIST } from 'domain/sales/lead/shared/leadService';
import LeadStatusDropdown from 'domain/sales/lead/shared/input/LeadStatusDropdown';
import DisqualificationReasonDropdown from 'domain/sales/lead/shared/input/DisqualifiactionReasonDropdown';
import LeadGradeDropdownWithDetails from 'domain/sales/lead/shared/input/LeadGradeDropdownWithDetails';
import LeadOwnerNotificationCheckbox from 'domain/sales/lead/shared/input/LeadOwnerNotificationCheckbox';
import IndustryDropdown from 'domain/sales/shared/input/IndustryDropdown';
import LeadSourceDropdown from 'domain/sales/lead/shared/input/LeadSourceDropdown';
import LeadMediumDropdown from 'domain/sales/lead/shared/input/LeadMediumDropdown';
import { CrmAttachmentUploaderInput } from 'domain/shared/artifact/input';

const LeadForm = () => {
  const { isGranted } = useAuthorization();
  return (
    <>
      <FormSection title="Lead information">
        <FormRow>
          <TextInput source="title" />
          <TextInput source="firstName" label="First name" />
          <TextInput source="middleName" label="Middle name" />
          <TextInput source="lastName" label="Last name" />
        </FormRow>

        <FormRow>
          <TextInput source="email" />
          <TextInput source="additionalEmail" label="Additional email" />
          <PhoneInput label="Phone" source="phoneNumber" hasExtension />
          <TextInput label="LinkedIn" source="linkedInLink" />
        </FormRow>

        <FormRow>
          <LeadStatusDropdown source="status" />
          <DisqualificationReasonDropdown
            source="disqualificationReason"
            isVisible={data => data.status === 'DISQUALIFIED'}
          />
          <ClearAfterUnmountWrapper isVisible={data => data.status === 'POSTPONED'}>
            <PostponedReasonDropdown source="postponedReason" />
          </ClearAfterUnmountWrapper>
          <ClearAfterUnmountWrapper isVisible={data => data.status === 'POSTPONED'}>
            <DateInput source="postponedReviewDate" />
          </ClearAfterUnmountWrapper>
        </FormRow>

        <FormRow>
          <LeadGradeDropdownWithDetails source="grade" />
          <TextArea source="gradingDetails" rows={8} isVisible={data => data.grade} />
        </FormRow>

        <FormRow>
          <CrmOwnerDropdownInput
            source="ownerAlias"
            canUserChange={isGranted(CHANGE_OWNER) || isGranted(READ_FULL_LEADS_LIST)}
            dropdownPlaceholder="Choose lead owner"
            label="Lead owner"
          />
          <LeadOwnerNotificationCheckbox source="ownerNotificationEnabled" label="Notify new Owner via Teams" />
        </FormRow>

        <FormRow>
          <TextInput source="companyName" label="Company" />
          <IndustryDropdown source="industry" />
          <TextInput source="websiteAddress" label="Website" />
          <TextInput source="employeesCount" label="No. of workers" />
        </FormRow>

        <FormRow>
          <LeadSourceDropdown source="source" />
          <TextInput source="sourceSite" label="Source site" />
          <LeadMediumDropdown source="medium" />
          <TextInput source="campaign" label="Marketing campaign" />
        </FormRow>
      </FormSection>

      <FormSection title="Address information">
        <AddressInput source="address" addressLine1Label="Street" zipLabel="Zip/Postal code">
          <TimezoneDropdown label="Time zone" source="addressTimezone" placeholder="Select timezone" />
        </AddressInput>
      </FormSection>

      <FormSection title="Description">
        <BigFormRow>
          <TextArea source="description" rows={8} />
        </BigFormRow>
        <BigFormRow>
          <CrmAttachmentUploaderInput label="Attachments" source="attachmentsIds" />
        </BigFormRow>
      </FormSection>

      <FormSection title="Visitor details">
        <FormRow>
          <TextInput source="ip" label="IP address" />
          <TextInput source="userAgent" label="User-Agent" />
          <TextInput source="httpRefer" label="HTTP referer" />
          <TextInput source="googleAnalystClientId" label="Google Analytics client ID" />
          <TextInput source="googleAdsClickId" label="Google Click ID" />
          <TextInput source="requestId" label="Lead autocreation request ID" />
        </FormRow>
      </FormSection>
    </>
  );
};

export default LeadForm;
